module.exports = __webpack_public_path__ + "eef9dc697770b10e8d9a821d66fba651.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/team/team-member-eytan.png
// module id = 655
// module chunks = 0